<app-stages [stages]="stages" currentStage="Informacje podstawowe"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-md-4">
        <div class='form-group' *ngIf='"applyingAs" as controlName'>
          <label [for]='controlName'>
            Składam wniosek jako *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.applyingOptions; track $index) {
              <option [value]="item">
                {{ item }}
              </option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <p id="propertyTypeDesc" class="pb-3">
          Rodzaj nieruchomości której dotyczy deklaracja o wysokości opłaty za gospodarowanie odpadami komunalnymi *:
        </p>
        <div class="row">
          <div class="col-12">
            <div class="form-group" *ngIf='"propertyType" as controlName'>
              @for (item of form.propertyTypeOptions; track $index) {
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="propertyTypeDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         type="radio"
                         [id]="controlName + $index"
                         [value]="item">
                  <label [for]="controlName + $index">
                    {{ item }}
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p id="submissionPurposeDesc" class="pb-3">
          Cel złożenia deklaracji *:
        </p>
        <div class="row">
          <div class="col-12">
            <div class="form-group" *ngIf='"submissionPurpose" as controlName'>
              @for (item of form.submissionPurposeOptions; track $index) {
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="submissionPurposeDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         type="radio"
                         [id]="controlName + $index"
                         [value]="item">
                  <label [for]="controlName + $index">
                    {{ item }}
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <p id="entityKindDesc" class="pb-3">
          Rodzaj własności składającego deklarację *:
        </p>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group" *ngIf='"entityKind" as controlName'>
              @for (item of form.entityKindOptions; track $index) {
                @if ($index <= 7) {
                  <div class="custom-radio">
                    <input aria-labelledby="entityKindDesc"
                           [name]="controlName"
                           [formControlName]='controlName'
                           type="radio"
                           [id]="controlName + $index"
                           [value]="item">
                    <label [for]="controlName + $index">
                      {{ item }}
                    </label>
                  </div>
                }
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" *ngIf='"entityKind" as controlName'>
              @for (item of form.entityKindOptions; track $index) {
                @if ($index > 7) {
                  <div class="custom-radio">
                    <input aria-labelledby="entityKindDesc"
                           [name]="controlName"
                           [formControlName]='controlName'
                           type="radio"
                           [id]="controlName + $index"
                           [value]="item">
                    <label [for]="controlName + $index">
                      {{ item }}
                    </label>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='application-actions'>
      @if (!uiSettings()?.mobileEmbed) {
        <button
          type='button'
          class='btn btn-secondary'
          (click)='onCancel()'>
        <span>
          Wstecz
        </span>
        </button>
      }
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
